"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const CameraTakePictureIcon = props => /*#__PURE__*/_react.default.createElement(_base.Icon, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="12" cy="12" r="5"/><path fill-rule="nonzero" d="M12 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12m0 1a7 7 0 1 1 0-14 7 7 0 0 1 0 14"/></g></svg>`
}, props));
CameraTakePictureIcon.displayName = 'CameraTakePictureIcon';
var _default = exports.default = CameraTakePictureIcon;